module.exports = __webpack_public_path__ + "static-appopensalud/img/openhealth_360_healthier_lives_color_MEX.7542818.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/openhealth_360_healthier_lives_color_MEX.svg
// module id = 1060
// module chunks = 120